<div class="container">
  <div class="row"><div class="col-12"><h3 style="color:#719eb6">BIP - Behaviors</h3></div></div>
  <div class="row mb-3">
    <div class="col-12 d-flex align-items-center gap-2">
      <p-selectButton *ngIf="canEditBip" [options]="[
        { label: 'Draft', value: false },
        { label: 'Current', value: true }
      ]" [ngModel]="startCurrentView" (onChange)="onGlobalViewChange($event)" autoWidth="false"
        [style]="{ display: 'inline-flex' }" allowEmpty="false">
      </p-selectButton>
      <span class="ms-2">{{ startCurrentView ? 'Viewing Current' : 'Editing Draft' }}</span>
      <button
        *ngIf="canEditBip && !startCurrentView"
        type="button"
        class="side-menu-button2 floating-save-button"
        (click)="saveAllDrafts()"
        [disabled]="savingAllDrafts()"
        [attr.aria-busy]="savingAllDrafts()"
      >{{ savingAllDrafts() ? 'Saving...' : 'Save Changes' }}</button>
    </div>
  </div>
  @for (behavior of behaviors(); track behavior.ID) {
    <div class="row mb-3" style="border: 2px solid #e1e8fb; border-radius: 10px; padding-top: 25px; background-color: #e1e8fb;">
      <div class="col-12">
        <app-behavior-bip-info
          [patientID]="patientID()"
          [selectedBehavior]="behavior"
          [behaviorID]="behavior.ID!"
          [startCurrentView]="startCurrentView"
          [showDraftToggle]="false"
          [showSaveButton]="false"
          [canEditBip]="canEditBip"
          [useOfflineData]="useOfflineData()"
        ></app-behavior-bip-info>
      </div>
    </div>
  }

</div>


